import { COMPONENT_DSL_NAMES, COMPONENT_DSL_PROP_TYPES, COMPONENT_DSL_TYPES, MENU_GROUP_NAMES, } from '../../../constants';
import { visibleByCondition } from '../../common/commonPresentations';
import { commonComponentProps } from '../../common/commonProps';
import { MaterialIconButtonSettings } from './MaterialIconButton.settings';
export const MaterialIconButton = {
    name: COMPONENT_DSL_NAMES.MaterialIconButton,
    displayName: 'Icon Button',
    icon: 'iconButton',
    type: COMPONENT_DSL_TYPES.reactImportComponent,
    componentListGroupName: MENU_GROUP_NAMES.other,
    source: {
        importName: '@builder/components',
        codeEngineImportName: 'shared/components',
        componentName: 'IconButton',
    },
    overlayOutlineWhenEmpty: true,
    schema: {
        dndTargetPropName: 'children',
        presentations: [visibleByCondition],
        predefineds: {
            props: {
                color: 'default',
                size: 'medium',
                type: 'button',
                label: 'Icon Button',
                children: {
                    nodes: [
                        {
                            name: COMPONENT_DSL_NAMES.BuilderComponentsIcon,
                            props: {
                                name: 'MoreVert',
                                style: {
                                    display: 'flex',
                                },
                            },
                        },
                    ],
                },
            },
        },
        props: Object.assign(Object.assign({}, commonComponentProps), { children: {
                type: COMPONENT_DSL_PROP_TYPES.reactNode,
                allowedNodes: [COMPONENT_DSL_NAMES.BuilderComponentsIcon],
                required: true,
            }, color: { type: COMPONENT_DSL_PROP_TYPES.enum }, disabled: { type: COMPONENT_DSL_PROP_TYPES.boolean }, disableElevation: { type: COMPONENT_DSL_PROP_TYPES.boolean }, disableFocusRipple: { type: COMPONENT_DSL_PROP_TYPES.boolean }, disableRipple: { type: COMPONENT_DSL_PROP_TYPES.boolean }, fullWidth: { type: COMPONENT_DSL_PROP_TYPES.boolean }, href: { type: COMPONENT_DSL_PROP_TYPES.string }, size: { type: COMPONENT_DSL_PROP_TYPES.enum }, variant: { type: COMPONENT_DSL_PROP_TYPES.enum }, target: { type: COMPONENT_DSL_PROP_TYPES.enum }, type: { type: COMPONENT_DSL_PROP_TYPES.string }, label: { type: COMPONENT_DSL_PROP_TYPES.string } }),
    },
    settings: MaterialIconButtonSettings,
};
